<template>
  <el-form ref="cameraForm" :model="cameraForm" :rules="cameraRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="cameraForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[cameraForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="国标设备编号" prop="deviceNoNational">
          <template v-if="!isDetail()">
            <el-row>
              <el-radio-group
                v-model="cameraForm.interGeneration"
                @change="nationalChose"
                placeholder="请选择"
              >
                <el-radio label="0">选择现有</el-radio>
                <el-radio label="1">系统生成</el-radio>
              </el-radio-group>
            </el-row>
            <el-row v-if="cameraForm.interGeneration == 0">
              <el-select
                style="width: 100%"
                filterable
                placeholder="请输入内容"
                v-model="cameraForm.deviceNoNational"
              >
                <el-option
                  v-for="item in nationalList"
                  :key="item.id"
                  :label="item.deviceNoNational"
                  :value="item.deviceNoNational"
                ></el-option>
              </el-select>
            </el-row>
            <el-row v-if="cameraForm.interGeneration == 1">
              <GB28181
                ref="nationalNo"
                :areaList="areaList"
                v-model="cameraForm.deviceNoNational"
              />
              <el-input
                style="margin-top: 8px"
                class="select-search"
                v-model="cameraForm.deviceNoNational"
                placeholder="上方内容均选择后，自动生成编号"
                disabled
              ></el-input>
            </el-row>
          </template>
          <span v-else>{{ cameraForm.deviceNoNational }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="视频通道编号" prop="channelNo1">
          <template v-if="!isDetail()">
            <GB28181
              ref="channleNo"
              :areaList="areaList"
              v-model="cameraForm.channelNo1"
              :isChannel="true"
            />
            <el-input
              v-model="cameraForm.channelNo1"
              placeholder="上方内容均选择后，自动生成编号"
              disabled
            ></el-input>
          </template>
          <span v-else>{{ cameraForm.channelNo1 }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备序列号" prop="serialNum">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.serialNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.serialNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通道个数" prop="channelNum">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.channelNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.channelNum || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="硬盘个数" prop="hardDiskNum">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.hardDiskNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.hardDiskNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报警输入个数" prop="callInNum">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.callInNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.callInNum || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报警输出个数" prop="callOutNum">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.callOutNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.callOutNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="主控版本" prop="masterVersion">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.masterVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.masterVersion || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="编码版本" prop="codeVersion">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.codeVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.codeVersion || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Web版本" prop="webVersion">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.webVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.webVersion || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Plugin版本" prop="pluginVersion">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.pluginVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.pluginVersion || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发布日期" prop="time">
          <el-date-picker
            v-if="!isDetail()"
            value-format="yyyy-MM-dd"
            v-model="cameraForm.time"
            type="date"
            placeholder="请选择日期"
          >
          </el-date-picker>
          <span v-else>{{ cameraForm.time || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备物理地址（mac）" prop="mac">
          <el-input
            v-if="!isDetail()"
            v-model="cameraForm.mac"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ cameraForm.mac || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import GB28181 from './GB28181Create';
import deviceApi from 'api/home/device-mangement';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    GB28181
  },
  props: {
    value: {
      type: Object
    },
    deviceCategoryId: {
      default: ''
    },
    areaList: {
      default: () => []
    },
    orgId: {
      default: ''
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      history: {
        deviceNoNational: '',
        channelNo1: '',
        interNoGetSelect: {
          administrativeAreas: [],
          industry: '',
          deviceType: '',
          networkAccess: ''
        }
      },
      nationalList: [],
      cameraForm: {}
    };
  },
  created() {
    this.$attrs.id && this.remberHistory();
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.cameraForm = newVal;
      }
    },
    cameraForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    },
    orgId: {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        newVal && this.getNationList();
      }
    }
  },
  computed: {
    cameraRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }],
        deviceNoNational: [
          { required: !this.isDetail(), message: '请选择国际设备编号', trigger: 'blur' }
        ],
        channelNo1: [{ required: !this.isDetail(), message: '请生成视频通道编号', trigger: 'blur' }]
      };
    }
  },
  methods: {
    nationalChose(val) {
      this.cameraForm.deviceNoNational = '';
      if (val == 0) {
        // this.getNationalList();
        return;
      }
      if (val == 1) {
        // this.getNationNo();
        return;
      }
    },
    getNationList() {
      deviceApi.getGbHistory({ orgId: this.orgId }).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.nationalList = data;
      });
    },
    reset() {
      this.nationalList = [];
      this.$refs.cameraForm.resetFields();
      this.$refs.nationalNo && this.$refs.nationalNo.reset();
      this.$refs.channleNo && this.$refs.channleNo.reset();
      this.cameraForm.interGeneration = '0';
      this.history = {
        deviceNoNational: '',
        channelNo1: '',
        interNoGetSelect: {
          administrativeAreas: [],
          industry: '',
          deviceType: '',
          networkAccess: ''
        }
      };
    },
    validate() {
      let type;
      this.$refs.cameraForm.validate(validated => {
        type = validated;
      });
      return type;
    },
    remberHistory() {
      this.history = {
        deviceNoNational: '',
        channelNo1: '',
        interNoGetSelect: {
          administrativeAreas: [],
          industry: '',
          deviceType: '',
          networkAccess: ''
        }
      };
    },
    getNationAgian() {
      this.$refs.nationalNo.getNationNo();
    },
    getChannelAgian() {
      this.$refs.channleNo.getNationNo();
    },
    getData() {
      let data = {
        deviceModel: this.cameraForm.deviceModel,
        factoryNo: this.cameraForm.factoryNo,
        status: this.cameraForm.status,
        deviceNoNational: this.cameraForm.deviceNoNational,
        channelNo1: this.cameraForm.channelNo1,
        deviceSerialNumber: this.cameraForm.serialNum,
        channelNumber: this.cameraForm.channelNum,
        diskNumber: this.cameraForm.hardDiskNum,
        alarmInputNumber: this.cameraForm.callInNum,
        alarmOutputNumber: this.cameraForm.callOutNum,
        icVersion: this.cameraForm.masterVersion,
        codeVersion: this.cameraForm.codeVersion,
        webVersion: this.cameraForm.webVersion,
        pluginVersion: this.cameraForm.pluginVersion,
        physicalAddress: this.cameraForm.mac,
        releaseDate: this.cameraForm.time || ''
      };
      return data;
    },
    setData(data) {
      const {
        deviceModel,
        factoryNo,
        status,
        deviceNoNational,
        channelNo1,
        deviceSerialNumber,
        channelNumber,
        diskNumber,
        alarmInputNumber,
        alarmOutputNumber,
        icVersion,
        codeVersion,
        webVersion,
        pluginVersion,
        physicalAddress,
        releaseDate
      } = data;
      this.cameraForm.deviceModel = deviceModel;
      this.cameraForm.factoryNo = factoryNo;
      this.cameraForm.status = status;
      this.cameraForm.deviceNoNational = deviceNoNational;
      this.cameraForm.channelNo1 = channelNo1;
      this.cameraForm.serialNum = deviceSerialNumber;
      this.cameraForm.channelNum = channelNumber;
      this.cameraForm.hardDiskNum = diskNumber;
      this.cameraForm.callInNum = alarmInputNumber;
      this.cameraForm.callOutNum = alarmOutputNumber;
      this.cameraForm.masterVersion = icVersion;
      this.cameraForm.codeVersion = codeVersion;
      this.cameraForm.webVersion = webVersion;
      this.cameraForm.pluginVersion = pluginVersion;
      this.cameraForm.mac = physicalAddress;
      this.cameraForm.time = releaseDate;
    }
  }
};
</script>
<style lang="less" scoped>
.select-with-search {
  display: flex;
  /deep/.select-is-search {
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  /deep/ .select-search {
    input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
